module.exports = __webpack_public_path__ + "14608140642245b822f4118ed423ac7c.svg";